import { HttpClient } from '@angular/common/http';

import { mixinHttp, IBgxHttpRESTConfig } from '../http.mixin';

import { BgxHttpService } from '../../interceptors/http.service';

/**
 * Decorator used to give a service http capabilities using BgxHttpService
 * @deprecated will be removed in angular 10
 */
export function BgxHttp(config: IBgxHttpRESTConfig): <T extends new (...args: any[]) => {}>(constructor: any) => any {
  return function<T extends new (...args: any[]) => {}>(constructor: any): any {
    return class extends mixinHttp(constructor, config, BgxHttpService) {};
  };
}

/**
 * Decorator used to give a service http capabilities using HttpClient
 * @deprecated will be removed in angular 10
 */
export function BgxHttpClient(
  config: IBgxHttpRESTConfig,
): <T extends new (...args: any[]) => {}>(constructor: any) => any {
  return function<T extends new (...args: any[]) => {}>(constructor: any): any {
    return class extends mixinHttp(constructor, config, HttpClient) {};
  };
}
